module.exports = __webpack_public_path__ + "2d595f3f49eecef990809008f8ecf3b5.svg";